export default "__VITE_ASSET__CMmNbbvh__"